import * as types from "../mutation-types";

const mutations = {
  [types.SET_SEASONS]: (state, payload) => {
    state.seasons = payload;
  },
  [types.SET_SEASON]: (state, payload) => {
    state.season = payload;
  },
  [types.UPDATE_SEASON_ITEM]: (state, payload) => {
    state.seasons.splice(state.seasons.indexOf(
        state.seasons.find(c => c.uuid === payload.uuid)
    ), 1);
  },
}

export default mutations;
